import React, { useState, useEffect } from 'react';
// import useAsyncProcesses from 'src/hooks/useAsyncProcesses';
import { Card, Skeleton, notification, Tooltip, Space } from 'antd';
import { getEventsFilters, putEventsFilter } from 'src/api/securityAdvisor';
import useDictionary from 'src/hooks/useDictionary';
import PropTypes from 'prop-types';
import BarLoader from 'react-bar-loader';
import useTheme from 'src/hooks/useTheme';
import EventFiltersCheckboxGroup from './EventFiltersCheckboxGroup';
import { getDictionaryKey } from 'src/misc/Misc';
import { MdInfoOutline } from 'react-icons/md';
import { optionsRole, optionsAuthUser } from 'src/components/pages/SecurityAdvisor/Misc/misc';

const EventsFilter = ({ addingSubscription, onChange, protocol, endpoint }) => {
  const { theme } = useTheme();

  const entityTypeDictionary = useDictionary('sa-events-entitytype');

  // const { executeAsyncProcess } = useAsyncProcesses();

  const configTemplate = {
    Role: ['MemberAdd', 'MemberRemove'],
    AuthUser: ['AuthenticationFailed'],
  };

  const [eventsFilters, setEventsFilters] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    console.log('loadData()');

    // <adding>
    if (addingSubscription) {
      console.log('Adding subscription');
      setEventsFilters(configTemplate);
      if (onChange) onChange(configTemplate);
      return;
    }
    // </adding>

    // <modifying>
    // await executeAsyncProcess(async () => {
    setLoading(true);
    try {
      const result = await getEventsFilters(protocol, endpoint);
      setEventsFilters(result?.filter_config);
    } catch (error) {
      console.log('error');
      if (error?.toString()?.includes('404')) {
        console.log('Config not found');
        createConfiguration();
      }
    }
    setLoading(false);
    // });
    // </modifying>
  };

  const createConfiguration = async () => {
    console.log('createConfiguration()');

    // <adding>
    if (addingSubscription) {
      console.log('Adding subscription');
      return;
    }
    // </adding>

    // <modifying>
    // await executeAsyncProcess(async () => {
    setLoading(true);
    try {
      const result = await putEventsFilter({ protocol, endpoint, filter_config: configTemplate });
      setEventsFilters(result?.filter_config);
      notification.success({
        message: 'Success',
        description: 'New filter configuration has been created',
        duration: 5,
      });
      loadData();
    } catch (error) {
      console.log('error');
    }
    setLoading(false);
    // });
    // </modifying>
  };

  const roleOnChange = async (checkedValues) => {
    console.log('roleOnChange()', checkedValues);

    const newConfig = { ...(eventsFilters ?? configTemplate), Role: checkedValues };
    setEventsFilters(newConfig);

    // <adding>
    if (addingSubscription) {
      console.log('Adding subscription');

      if (onChange) onChange(newConfig);
      return;
    }
    // </adding>

    // <modifying>
    // await executeAsyncProcess(async () => {
    setLoading(true);
    try {
      const result = await putEventsFilter({ protocol, endpoint, filter_config: newConfig });
      setEventsFilters(result?.filter_config);
      notification.success({
        message: 'Success',
        description: 'Filter configuration has been updated',
        duration: 5,
      });
    } catch (error) {
      console.log('error');
    }
    setLoading(false);
    // });
    // </modifying>
  };

  const authUserOnChange = async (checkedValues) => {
    console.log('authUserOnChange()', checkedValues);

    const newConfig = { ...(eventsFilters ?? configTemplate), AuthUser: checkedValues };
    setEventsFilters(newConfig);

    // <adding>
    if (addingSubscription) {
      console.log('Adding subscription');
      if (onChange) onChange(newConfig);
      return;
    }
    // </adding>

    // <modifying>
    // await executeAsyncProcess(async () => {
    setLoading(true);
    try {
      const result = await putEventsFilter({ protocol, endpoint, filter_config: newConfig });
      setEventsFilters(result?.filter_config);
      notification.success({
        message: 'Success',
        description: 'Filter configuration has been updated',
        duration: 5,
      });
    } catch (error) {
      console.log('error');
    }
    setLoading(false);
    // });
    // </modifying>
  };

  return (
    <div>
      {loading ? <BarLoader color={theme.primary} backgroundColor={theme.light} height='2' width='100%' /> : <div style={{ height: '1px', marginTop: '-1px', backgroundColor: 'transparent' }}></div>}
      <div className={`my-4 flex flex-row flex-wrap gap-4 justify-center ${loading && 'disabled'}`}>
        <Card
          title={
            <Space className='btn my-2 w-36'>
              <div>{getDictionaryKey(entityTypeDictionary, 'Role')?.valueJson?.label ?? 'Role'}</div>
              <Tooltip title={getDictionaryKey(entityTypeDictionary, 'Role')?.valueJson?.desc ?? 'no description'}>
                <MdInfoOutline className='text-xs opacity-60' />
              </Tooltip>
            </Space>
          }
          size='small'
        >
          {!eventsFilters ? (
            <div className='flex flex-col gap-1 mt-1 items-center'>
              <Skeleton.Input active size={18} />
              <Skeleton.Input active size={18} />
              <Skeleton.Input active size={18} />
            </div>
          ) : (
            <EventFiltersCheckboxGroup entityType='Role' options={optionsRole} value={eventsFilters?.Role ?? []} onChange={roleOnChange} />
          )}
        </Card>
        <Card
          title={
            <Space className='btn my-2 w-36'>
              <div>{getDictionaryKey(entityTypeDictionary, 'AuthUser')?.valueJson?.label ?? 'Role'}</div>
              <Tooltip title={getDictionaryKey(entityTypeDictionary, 'AuthUser')?.valueJson?.desc ?? 'no description'}>
                <MdInfoOutline className='text-xs opacity-60' />
              </Tooltip>
            </Space>
          }
          size='small'
        >
          {!eventsFilters ? (
            <div className='flex flex-col gap-1 mt-1 items-center'>
              <Skeleton.Input active size={18} />
              <Skeleton.Input active size={18} />
              <Skeleton.Input active size={18} />
            </div>
          ) : (
            <EventFiltersCheckboxGroup entityType='AuthUser' options={optionsAuthUser} value={eventsFilters?.AuthUser ?? []} onChange={authUserOnChange} />
          )}
        </Card>
      </div>
    </div>
  );
};

EventsFilter.propTypes = {
  addingSubscription: PropTypes.bool,
  onChange: PropTypes.func,
  protocol: PropTypes.string,
  endpoint: PropTypes.string,
};

EventsFilter.defaultProps = {
  addingSubscription: false,
};

export default EventsFilter;
